import React, { useState } from "react";
import NumberContainer from "./Number_container";
import "./Header.css";

function Header({ navItems, scrollToRef, activeIndex, onOrderClick }) {
  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url !== "undefined") {
        window.location = url;
      }
    };
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16886232342/m19jCI-i56AaEJbq_fM-",
        event_callback: callback,
      });
    }
    return false;
  }
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <div className="header-general">
        <div className="header-general_container">
          {/* {"  "} */}
          <img src="./img/logo.png" alt="logo" className="logo" />

          <div className="header_nav-container">
            <div className="header-brand">
              <ul className="header_nav_list list">
                {/* Кнопка Покрівля с выпадающим меню */}
                <li className="header_nav_item">
                  <p className="svg-text">
                    Покрівля{" "}
                    <svg
                      className="header_nav_svg"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#000000"
                      width="10px"
                      height="10px"
                      viewBox="0 0 32 32"
                      version="1.1"
                    >
                      <path d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z" />
                    </svg>
                  </p>
                  <ul className="dropdown-menu">
                    {navItems.slice(0, 2).map((item, index) => (
                      <li key={index} className="dropdown-item">
                        <a href={`#${item.id}`} className="header_nav_link">
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>

                {/* Остальные элементы навигации */}
                {navItems.slice(2).map((item, index) => (
                  <li
                    key={index + 2}
                    className={`header_nav_item ${
                      activeIndex === index + 2 ? "active" : ""
                    }`}
                  >
                    <a
                      href={`#${item.id}`}
                      className="svg-text header_nav_link"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <NumberContainer />
          <div
            className={`burger-menu ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <nav
            className={`header_nav-container_burger ${
              isMenuOpen ? "open" : ""
            }`}
          >
            <ul className="header_nav_list list">
              {navItems.map((item, index) => (
                <li
                  key={index}
                  className={`header_nav_item ${
                    activeIndex === index ? "active" : ""
                  }`}
                  onClick={() => {
                    scrollToRef(item.ref);
                    setMenuOpen(false); // Закрыть меню при клике на ссылку
                  }}
                >
                  <a href={`#${item.id}`} className="header_nav_link">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <div className="header_main-container">
        <img
          src="./img/header_house.png"
          alt="house"
          className="png_house"
        ></img>
        <div className="header_main-title">
          <h1 className="header_main-title-text">
            <ul className="header_main-title-list list">
              <li className="header_main-title">Надійний ремонт дахів</li>
              <li className="header_main-title">
                Професійний монтаж покрівель
              </li>
              <li className="header_main-title">Якісне обслуговування дахів</li>
            </ul>
            <ul className="header_main-title-tiny-text list">
              <li>💡 Безкоштовна консультація з експертами.</li>
              <li>🌟 Гарантія якості на всі види робіт.</li>
              <li>✔️ Індивідуальний підхід до кожного клієнта.</li>
              <li>📅 Замовляйте сервіс вже сьогодні!</li>
            </ul>
          </h1>
        </div>

        <div
          className="Soft-roof_btn-container btn-special_container"
          onClick={() => {
            gtag_report_conversion(); // Отправка события в Google Ads
            onOrderClick(); // Вызов вашего обработчика
          }}
        >
          <div className="feedback-container">
            <div className="feedback-border">
              <div className="feedback">
                <div className="feedback-text-container">
                  <p className="feedback-text">Замовити дзвінок</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
